import { Typography } from '@material-tailwind/react'
import PropTypes from 'prop-types'

export const GroupInput = ({ divider, title, description, children, ...props }) => {
  return (
    <>
      <section className='flex flex-col gap-8' {...props}>
        <div className='flex gap-36'>
          <div className='flex flex-col flex-[1] gap-2'>
            <Typography variant='h5'>
              {title}
            </Typography>
            <Typography variant='h6' className='text-gray-500 font-normal'>
              {description}
            </Typography>
          </div>

          <div className='w-full h-full flex flex-col gap-4 flex-[3]'>
            {children}
          </div>
        </div>
      </section>

      {
        divider &&
        <div className='grow h-px bg-gray-300'></div>
      }
    </>
  )
}

GroupInput.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  children: PropTypes.node,
  divider: PropTypes.bool
}

GroupInput.defaultProps = {
  divider: true
}
